import { PocBadge } from 'commons/components/components-wrapper/poc-badge.component';
import { PocTab } from 'commons/components/components-wrapper/poc-tab.component';
import { PocTabs } from 'commons/components/components-wrapper/poc-tabs.component';
import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { useTranslation } from 'core/i18n/i18n';
import { DeviceTypeDetails } from 'modules/devices/domain/api/device-type.api';
import { DeviceConfigurationInstance } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-configuration-layout/settings-devices-configuration-layout.model';
import { SettingsLayoutStyledHeader } from '../settings-devices-configuration.style';

export interface DeviceConfigurationHeaderProps {
    deviceConfigurationInstance: DeviceConfigurationInstance;
    deviceType?: DeviceTypeDetails;
    selectedTab: string;
    onTabChange: (tab: string) => void;
}

export const DeviceConfigurationHeader: React.FC<DeviceConfigurationHeaderProps> = ({
    deviceConfigurationInstance,
    deviceType,
    selectedTab,
    onTabChange,
}) => {
    const { t } = useTranslation();

    return (
        <SettingsLayoutStyledHeader>
            {deviceConfigurationInstance.id && (
                <div className="device-info">
                    <div className="title">
                        <div>
                            <PocTypography variant="title5">{deviceConfigurationInstance?.name}</PocTypography>
                            {deviceConfigurationInstance?.isByDefault && (
                                <PocBadge status="active" size="medium">
                                    {t('settings.devices.device-settings.device-config-list.default')}
                                </PocBadge>
                            )}
                        </div>
                        <PocTypography variant="body1">{deviceType?.name}</PocTypography>
                    </div>
                </div>
            )}
            <PocTabs elevated="none" size="small" value={selectedTab} onValueChange={(ev) => onTabChange(ev.detail)}>
                <PocTab value="edit-config">
                    <span>
                        {t(
                            'settings.devices.device-settings-device-config-layout.workflow.tab.configuration-properties'
                        )}
                    </span>
                </PocTab>
                <PocTab value="config">
                    {t('settings.devices.device-settings-device-config-layout.workflow.tab.edit-configuration')}
                </PocTab>
            </PocTabs>
        </SettingsLayoutStyledHeader>
    );
};
